/**
 * Configuration des feature flags
 * Permet d'activer/désactiver des fonctionnalités sans redéployer
 * 
 * Usage:
 * import { FEATURES } from './config/features';
 * 
 * if (FEATURES.USE_PORTFOLIO_V2) {
 *   // Utiliser PortfolioContextV2
 * } else {
 *   // Utiliser PortfolioContext
 * }
 */

/**
 * Feature flags disponibles
 */
export const FEATURES = {
  /**
   * Utiliser PortfolioContextV2 au lieu de PortfolioContext
   * Défini via la variable d'environnement REACT_APP_USE_PORTFOLIO_V2
   * Par défaut: false (utiliser l'ancien contexte)
   */
  USE_PORTFOLIO_V2: process.env.REACT_APP_USE_PORTFOLIO_V2 === 'true',
  
  /**
   * Activer le monitoring détaillé des performances
   */
  ENABLE_PERFORMANCE_MONITORING: process.env.REACT_APP_ENABLE_PERFORMANCE_MONITORING === 'true' || false,
  
  /**
   * Activer le prefetching intelligent
   */
  ENABLE_PREFETCHING: process.env.REACT_APP_ENABLE_PREFETCHING === 'true' || false,
  
  /**
   * Activer le lazy loading des composants
   */
  ENABLE_LAZY_LOADING: process.env.REACT_APP_ENABLE_LAZY_LOADING === 'true' || false,
};

export default FEATURES;

